import { getHours } from 'date-fns';

/**
 * Returns a greeting based on the current time of day.
 *
 * - "Bom dia" (Good morning) for hours between 5 AM and 12 PM.
 * - "Boa tarde" (Good afternoon) for hours between 12 PM and 7 PM.
 * - "Boa noite" (Good evening) for hours from 7 PM onwards.
 *
 * @returns {string} The appropriate greeting based on the current hour.
 */
export function greeting() {
  const currentDate = new Date();

  // Get the current hour using date-fns
  const currentHour = getHours(currentDate);

  // Define the greeting based on the current hour
  let greeting;
  if (currentHour >= 5 && currentHour < 12) {
    greeting = 'Bom dia'; // Morning greeting
  } else if (currentHour >= 12 && currentHour < 19) {
    greeting = 'Boa tarde'; // Afternoon greeting
  } else {
    greeting = 'Boa noite'; // Evening greeting
  }

  return greeting;
}

export function getInitials(name) {
  let parts = name.split(' '); // Split the name by space
  if (parts.length < 2) return ''; // Ensure there are at least two words
  return parts[0][0] + parts[1][0]; // Get first letter of first and last name
}
